<template>
  <div class="flex-page">
    <header v-if="hasPayOrder" class="pay-tip">
      <p>
        待支付
        <br />
        请在
        <span>{{ timeCount }}</span>
        内完成支付
      </p>
    </header>

    <section class="pay-info">
      <van-image round width="84" height="84" :src="doctorInfo.doctorAvatar | imgUrl" class="doctor-img">
        <template v-slot:error>
          <van-icon size="84" :name="require('../../assets/imgs/default-doctor-avatar.png')"></van-icon>
        </template>
      </van-image>

      <p class="price">
        <b>{{ doctorInfo.price }}</b>
        元/每次
      </p>

      <p class="name">{{ doctorInfo.doctorName }}医生的图文问诊服务</p>

      <van-button
        v-if="!payAgain"
        :disabled="isLoading || isTimeOut"
        type="primary"
        class="pay-btn"
        v-reClick="handlePay"
      >
        立即支付
      </van-button>

      <template v-else>
        <van-button :disabled="isTimeOut" type="primary" class="pay-btn margin0" v-reClick="() => handlePay()">
          继续支付
        </van-button>
        <van-button
          plain
          :disabled="isTimeOut"
          :border="false"
          type="primary"
          class="pay-btn text-btn"
          v-reClick="() => handleCancel()"
        >
          取消支付
        </van-button>
      </template>
    </section>

    <footer class="service">本服务由智云医道认证医生提供</footer>
  </div>
</template>

<script>
import ZYPay from '@zyf2e/checkout-sdk';
import { Dialog } from '@zyf2e/capui-mobile';
import utils from '@/util/index.js';

export default {
  data() {
    return {
      doctorInfo: {
        doctorId: '',
        doctorName: '',
        doctorAvatar: '',
        price: '',
        requirementId: ''
      },

      avatar: '',

      advisoryPay: null,

      isLoading: false,

      hasPayOrder: false,

      timeCount: '',

      expireTimestamp: 0,

      firstTime: 0,

      interval: null,

      isTimeOut: false,

      payAgain: false,

      payLock: false
    };
  },

  created() {
    this.doctorInfo = this.$route.query;

    this.hasPayOrder = !!this.$route.query.advisoryId;
    this.payAgain = false;
    if (this.$route.query.payAgain === 'true' || this.$route.query.payAgain === true) {
      this.payAgain = true;
    }
    if (this.hasPayOrder) {
      this.expireTimestamp = Number(this.$route.query.expireTimestamp);
      this.firstTime = Number(this.$route.query.now);
      this.returnCountDown('created');

      this.interval = setInterval(() => {
        this.returnCountDown();
      }, 1000);
    }
  },

  async mounted() {
    this.doctorInfo.requirementId = this.$route.query.requirementId || '';
    await ZYPay.init({
      ...util.ZYpayConfig,
      backEventType: 1 // 0：跳成功页面，  1: 关闭webview
    });
  },

  beforeDestroy() {
    this.clearInterval();
    this.interval = null;
  },

  methods: {
    returnCountDown(type) {
      const now = Date.now();
      const spareTime = this.expireTimestamp - (now - this.firstTime);
      if (spareTime > 0) {
        let timeCount = utils.toHHmmss(spareTime, 'en');
        if (timeCount) timeCount = timeCount.slice(3);
        this.timeCount = timeCount;
      } else {
        this.clearInterval();
        if (type !== 'created') {
          this.handleCancel('hide');
        }
        this.timeCount = '00:00';
        this.isTimeOut = true;
      }
    },

    // eslint-disable-next-line class-methods-use-this
    handlePay() {
      if (this.payLock) {
        this.$toast('支付中，请勿重复点击')
        return
      }
      this.payLock = true
      this.precessTelescope();

      this.isLoading = true;
      const { requirementId } = this.$route.query;
      this.$fetch
        .getPayAdvisoryTradeNo({
          doctorId: this.doctorInfo.doctorId,
          requirementId: requirementId || null
        })
        .then(async data => {
          this.isLoading = false;
          try {
            await ZYPay.prePay({ tradeNo: data.tradeNo });
            this.payLock = false
          }catch(error) {
            this.payLock = false
            if (error === 'INIT_ADAPT_ERROR') {
              Dialog.confirm({
                title: '温馨提示',
                message: '支付环境异常,请刷新重试',
                confirmButtonText: '立即重试'
              })
                .then(() => {
                  window.location.reload()
                  // on confirm
                })
                .catch((action) => {
                  // on cancel or assist
                });
                return
            }
            this.$toast(error && error.message ? error.message : error);
          }
          
        })
        .catch(() => {
          this.payLock = false
          this.isLoading = false;
        });
    },

    handleCancel(operate = 'close') {
      if (this.isTimeOut) return;
      const { advisoryId = '' } = this.$route.query;
      this.$fetch.postCancelAdvisory({ advisoryId: advisoryId || '' }).then(data => {
        if (operate === 'close') {
          this.$router.push({
            name: 'BindingDoctors'
          });
        }
      });
    },

    confirmCancel() {
      if (this.isTimeOut) return;
      this.precessTelescope('cancel');
      this.$dialog.confirm({ title: '', message: '是否确定取消当前订单', confirmButtonText: '确定' }).then(() => {
        this.handleCancel();
      });
    },
    clearInterval() {
      window.clearInterval(this.interval);
      this.interval = null;
    },

    precessTelescope(type) {
      if (this.payAgain) {
        const timeStamp = new Date().getTime();
        if (type === 'cancel') {
          Telescope.trackEvent({
            trackId: 'zyyd-click-wdys-ljzx-qxzf',
            custom: {
              timeStamp,
              doctorId: this.doctorInfo.doctorId || ''
            }
          });
        } else {
          // 医道埋点：
          Telescope.trackEvent({
            trackId: 'zyyd-click-wdys-ljzx-jxzf',
            custom: {
              timeStamp,
              doctorId: this.doctorInfo.doctorId || ''
            }
          });
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.flex-page {
  display: flex !important;
  min-height: 100%;
  flex-direction: column;
  padding-bottom: 10px;
  background: #ffffff;
  .margin0 {
    margin: 0 !important;
  }
  .pay-tip {
    width: 100%;
    padding: 0 28px;
    background: url('../../assets/imgs/advisory-unpay.png') no-repeat top left/100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 108.5px;
    p {
      width: 100%;
      font-size: 16px;
      line-height: 32px;
      font-weight: 500;
      color: #595959;
      span {
        color: #ff8200;
      }
    }
  }
  .doctor-img {
    margin-bottom: 15.5px;
  }
  .pay-info {
    margin-top: 21px;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 16px;
    padding-top: 0;
    .price {
      text-align: center;
      font-size: 12px;
      color: #262626;
      margin-bottom: 13.5px;
      b {
        font-size: 38px;
        color: #ff4e47;
      }
    }
    .name {
      text-align: center;
      font-size: 14px;
      color: #333333;
      margin-bottom: 20.5px;
    }
    .pay-desc {
      font: 400 12px/21px PingFangSC-Regular, PingFang SC;
      color: #999999;
      h5 {
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 8px;
      }
      a {
        color: #4991fd;
      }
    }
    .pay-btn {
      width: 100%;
      border-radius: 4px;
      margin-bottom: 38.5px;
    }
    .text-btn {
      margin-top: 8px;
      color: #8c8c8c;
    }
  }
  .service {
    font-size: 10px;
    color: #666666;
    text-align: center;
  }
}
</style>
